// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__2lwyz","disabled":"FileBtn_disabled__1tiB1","warn":"FileBtn_warn__3jr9g","fade":"FileBtn_fade__Eidrf"};